import { render } from "./ScalableModalAlone.vue?vue&type=template&id=6198d9c2&scoped=true"
import script from "./ScalableModalAlone.vue?vue&type=script&lang=js"
export * from "./ScalableModalAlone.vue?vue&type=script&lang=js"

import "./ScalableModalAlone.vue?vue&type=style&index=0&id=6198d9c2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6198d9c2"]])

export default __exports__